define("shared/components/shared/media-library", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _tracking, _emberConcurrency, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cLIB--board eLib--board cCM--mediaLibrary" data-test-id="media-library">
    <div class="cLIB--boardHeader__upload">
      <Shared::AssetUpload @dropDisabled={{true}} @location="post_modal" />
    </div>
    <div class="cLIB--scrollContainer" {{perfect-scroll}}>
      <div class="cLIB--boardList gd--sideLibrary--media_grid">
        <ol class="cLIB--boardListContainer fc-draggable-wrapper">
          {{#each this.orderedMediaItems as |item|}}
            <Shared::MediaItems::MediaItem @mediaItem={{item}} />
          {{/each}}
        </ol>
  
        {{#if this.displayLoadMore}}
          <Shared::Ui::Button
            @class="o--btn--lg o--btn--outline o--btn--block u--text--hl u--m__tb"
            @isDisabled={{this.isLoadingMore}}
            @promise={{this.loadMore}}
            @runningText={{t "shared_words.loading"}}
            @text={{if this.isLoadingMore (t "shared_words.loading") (t "shared_phrases.load_more")}}
            @variant="outline"
          />
        {{else}}
          <span class="o--btn--sm u--text--light o--btn--block u--m__tb__sm">
            {{t "shared_phrases.no_more"}}
          </span>
        {{/if}}
      </div>
    </div>
  </div>
  */
  {
    "id": "YUYc5s04",
    "block": "[[[10,0],[14,0,\"cLIB--board eLib--board cCM--mediaLibrary\"],[14,\"data-test-id\",\"media-library\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cLIB--boardHeader__upload\"],[12],[1,\"\\n    \"],[8,[39,0],null,[[\"@dropDisabled\",\"@location\"],[true,\"post_modal\"]],null],[1,\"\\n  \"],[13],[1,\"\\n  \"],[11,0],[24,0,\"cLIB--scrollContainer\"],[4,[38,1],null,null],[12],[1,\"\\n    \"],[10,0],[14,0,\"cLIB--boardList gd--sideLibrary--media_grid\"],[12],[1,\"\\n      \"],[10,\"ol\"],[14,0,\"cLIB--boardListContainer fc-draggable-wrapper\"],[12],[1,\"\\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"orderedMediaItems\"]]],null]],null],null,[[[1,\"          \"],[8,[39,4],null,[[\"@mediaItem\"],[[30,1]]],null],[1,\"\\n\"]],[1]],null],[1,\"      \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"displayLoadMore\"]],[[[1,\"        \"],[8,[39,6],null,[[\"@class\",\"@isDisabled\",\"@promise\",\"@runningText\",\"@text\",\"@variant\"],[\"o--btn--lg o--btn--outline o--btn--block u--text--hl u--m__tb\",[30,0,[\"isLoadingMore\"]],[30,0,[\"loadMore\"]],[28,[37,7],[\"shared_words.loading\"],null],[52,[30,0,[\"isLoadingMore\"]],[28,[37,7],[\"shared_words.loading\"],null],[28,[37,7],[\"shared_phrases.load_more\"],null]],\"outline\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"o--btn--sm u--text--light o--btn--block u--m__tb__sm\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[\"shared_phrases.no_more\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"item\"],false,[\"shared/asset-upload\",\"perfect-scroll\",\"each\",\"-track-array\",\"shared/media-items/media-item\",\"if\",\"shared/ui/button\",\"t\"]]",
    "moduleName": "shared/components/shared/media-library.hbs",
    "isStrictMode": false
  });
  let MediaLibraryComponent = _exports.default = (_class = class MediaLibraryComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "store", _descriptor4, this);
      _initializerDefineProperty(this, "displayLoadMore", _descriptor5, this);
      _defineProperty(this, "loadMore", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const lastObject = this.orderedMediaItems.get('lastObject');
          const lowestDate = lastObject?.get('createdTime');
          try {
            const mediaItems = yield this.store.query('media-item', {
              start_date: lowestDate,
              limit: _constants.MEDIA_ITEM_LOAD_LIMIT
            });
            if (mediaItems.get('length') < _constants.MEDIA_ITEM_LOAD_LIMIT) {
              this.displayLoadMore = false;
            }
          } catch (error) {
            this.alerts.warning(this.intl.t('alerts.generic_error_message'), {
              title: this.intl.t('alerts.calendar.side_library.load_more_failed.title')
            });
          }
        }
      }), null, "loadMore", "drop"));
    }
    get isLoadingMore() {
      return this.loadMore.isRunning;
    }
    get mediaItems() {
      return this.store.peekAll('media-item').filter(mediaItem => {
        return mediaItem.group.get('id') === this.auth.currentGroup.id;
      });
    }
    get imageMediaItems() {
      return this.mediaItems.filterBy('mediaType', 'image');
    }
    get orderedMediaItems() {
      if (this.args.filterImages) {
        return this.imageMediaItems.sortBy('createdTime').reverse();
      }
      return this.mediaItems.sortBy('createdTime').reverse();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "displayLoadMore", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MediaLibraryComponent);
});